export default "__VITE_ASSET__DtLguiij__"